import ReactTooltip from 'react-tooltip';
import JsonQuery from 'json-query';
import {
    types as commonTypes,
    utils as commonUtils,
    hooks as commonHooks,
} from '@sitebuilder/common';
import { isLocalStorageAccessible } from '../utils';

interface WidgetProperties extends commonTypes.WidgetInstanceProps {
    dataContext: any;
    emailBtnTransformFunc?: string;
    emailBtnDataKey?: string;
    emailBtnLocalStorageItemName?: string;
    receiverEmailId?: string;
    emailSubject?: string;
    emailOnHoverText?: string;
    emailButtonText?: string;
    emailButtonTooltipTextColor?: string;
    emailButtonTooltipBgColor?: string;
    params?: URLSearchParams;
}

export default function EmailContainer(props: WidgetProperties) {
    const {
        dataContext,
        emailBtnDataKey,
        emailBtnTransformFunc,
        emailBtnLocalStorageItemName,
        receiverEmailId,
        emailSubject,
        emailOnHoverText,
        emailButtonText,
        emailButtonTooltipTextColor,
        emailButtonTooltipBgColor,
        params,
    } = props;
    const data = emailBtnDataKey
        ? JsonQuery(`${emailBtnDataKey}`, { data: dataContext }).value
        : dataContext;
    const i18n = commonHooks.useLocalization();
    const storageName = i18n.format(emailBtnLocalStorageItemName, data) || 'favorites';

    const _isLocalStorageAccessible: boolean = isLocalStorageAccessible();

    let emailText = 'This is test email';
    let emailBtnText = i18n.format(emailButtonText, data) || i18n.t('email');
    const transformFunctionName = `${props.widgetInstanceId}-transform`;

    if (emailBtnTransformFunc) {
        const transformedData = commonUtils.transformDataWithGlobals(
            transformFunctionName,
            emailBtnTransformFunc,
            {
                data,
                _isLocalStorageAccessible,
                storageName,
                params,
            }
        );

        if (typeof transformedData === 'string') {
            emailText = transformedData;
        } else {
            emailText = encodeURIComponent(transformedData.emailText);
            emailBtnText = transformedData.emailBtnText;
        }
    }

    const mailToUri = `mailto:${receiverEmailId}?subject=${i18n.format(
        emailSubject,
        data
    )}&body=${emailText}`;

    return (
        <>
            <div
                className="email-container"
                data-tip
                data-for="email-tooltip"
                data-text-color={emailButtonTooltipTextColor || '#fff'}
                data-background-color={emailButtonTooltipBgColor || '#000'}
            >
                {/* key property is added for button to fix
                re-rendering issue on server side */}
                <a
                    key={`email-btn-${new Date().getTime()}`}
                    href={mailToUri}
                    target="_blank"
                    rel="noreferrer"
                    dangerouslySetInnerHTML={{ __html: emailBtnText }}
                />
            </div>
            <ReactTooltip id="email-tooltip" place="top" effect="solid" className="email-tooltip">
                {i18n.format(emailOnHoverText, data)}
            </ReactTooltip>
        </>
    );
}
